import React from "react";
import AgendaItem from './AgendaItem/AgendaItem.js';
import Axios from "axios";
import { BASE_PATH } from "../constants/awsBaseUrl.js";


const Agenda = (props) => {
  let [state, setState] = React.useState({ success: true, agendas: [], captions: [] });

  const mountedRef = React.useRef(null);

  React.useEffect(() => {
    const getAgenda = async () => {
      try {
        const link = `https://api.castus.tv/ccs/v1/agenda/${props.video}`
        const res = await Axios.get(link);
        if (res?.data && res?.status === 200) {
          const { data } = res;
          setState({ ...state, agendas: data, success: true });
        };
      } catch (err) {
        console.error(err);
        setState({ ...state, agendas: props.items, success:false });
      };
    };
    getAgenda();
  }, []);
  
  React.useEffect(() => {
    const getCaptions = async (video) => {
      Axios.get(`${BASE_PATH}/captions/${video}.vtt`)
        .then((res) => {
          if(!mountedRef.current) {
            return
          }
          let cap = [];
          let tmp = {};
          res.data.split("\n").forEach((line) => {
            if (line.length && line !== "WEBVTT") {
              if (tmp.start) {
                tmp.text = line;
                cap.push(tmp);
                tmp = {};
              } else {
                tmp.start = toSeconds(line.split(" --> ")[0]);
                tmp.end = toSeconds(line.split(" --> ")[1]);
                tmp.duration = tmp.end - tmp.start;
                tmp.key = `${Math.random() * 10000000}${new Date().getTime()}`;
              }
            }
          });
          setState({ ...state, captions: cap });
        })
        .catch(() => {});
    };
    if (!state?.success) {
      getCaptions(props.video);
    };
  }, [props.video]);

  const toSeconds = (time) => {
    if (time) {
      let seconds = parseFloat(time.split(":")[2]);
      seconds = seconds + parseFloat(time.split(":")[1]) * 60;
      seconds = seconds + parseFloat(time.split(":")[0]) * 60 * 60;
      return seconds;
    } else {
      return 0;
    }
  };
  let agenda = state.agendas.map(item => {
    return (
      <AgendaItem 
        key={item.title + item.time}
        item={item}
        curentTime={props.curentTime}
        scrubTo={props.scrubTo}
        color={props.color}
        url={props.url}
        video={props.video}
      /> 
    )
  })
  // let agenda = props.items
  //   .map(item => {
  //     return {
  //       ...item,
  //       captions: state.captions.filter((cap) => {
  //         return cap.end >= item.time && cap.start <= item.time + item.duration;
  //       }),
  //     };
  //   })
  //   .map(item => {
  //     return (
  //       <AgendaItem key={item.title + item.time}
  //         item={item}
  //         curentTime={props.curentTime}
  //         scrubTo={props.scrubTo}
  //         color={props.color}
  //         url={props.url}
  //         video={props.video}
  //       />
  //     );
  //   });
  //Agenda Items Container
  return ( props.items.length > 0 && 
    <div className="agenda-container list-group mb-3" ref={mountedRef}>
      {agenda}
    </div>
  )
};

export default Agenda;
